import i18n from '@/i18n/i18n';

export default [
    {
        path: '/shelter-fee/reports',
        name: 'shelter-fee-reports',
        component: () => import('@/views/app/shelter-fee/pages/reports/Index.vue'),
        meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU Repse'],
            breadcrumb: [
                { title: 'Home', url: '/' },
                { title: i18n.messages[i18n.locale].reports, url: '/shelter-fee/reports', active: true },
            ]
        }
    },
]
